import Projects from '../components/projects.svelte'
import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
	init() {
		scrollReveals()
		parallax()
		let $projectsWrap = $('#projects-app')
		if ($projectsWrap.length) {
			new Projects({
				target: $projectsWrap[0],
				props: $projectsWrap.data(),
			})
		}
	},
	finalize() {},
}

function scrollReveals() {
	let $planningProjects = $('.pp-item')
	if ($planningProjects.length) {
		let pp_tl = gsap.timeline({
			scrollTrigger: {
				trigger: 'section.planning-projects',
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
                // markers: true,
			},
		})
		$planningProjects.each(function (i) {
			pp_tl.fromTo(
				$(this)[0],
				{
					opacity: 0,
					x: -40,
				},
				{
					delay: i * 0.001,
					duration: 0.5,
					opacity: 1,
					x: 0,
				}
			)
		})
	}
}

function parallax() {
	let scrollAnimations = []

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap .compass-svg')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--pr':
					innerWidth > 600
						? {
								from: '55deg',
								to: '40deg',
						  }
						: {
								from: '55deg',
								to: '40deg',
						  },
			},
		})
	)

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
